import { Button, ButtonGroup, VFlow } from 'bold-ui'
import { useState } from 'react'

import { AgendamentoBox } from '../components/AgendamentoBox'
import { LotacaoCadastroAgendamentoText } from '../components/LotacaoCadastroAgendamentoText'
import { LotacaoAgendaModel, TipoAgendamento } from '../model-agenda'
import { AgendamentoConsultaCompartilhadaForm } from './AgendamentoConsultaCompartilhadaForm'
import { AgendamentoConsultaForm } from './AgendamentoConsultaForm'
import { AgendamentoReservaForm } from './AgendamentoReservaForm'

export interface AgendamentoCadastroViewProps {
  lotacao: LotacaoAgendaModel
  isAtencaoDomiciliar?: boolean
  onSubmit?(): void
  onClose?(): void
  start: number
  end: number
  defaultTab?: TipoAgendamento.CONSULTA | TipoAgendamento.RESERVA | TipoAgendamento.CONSULTA_COMPARTILHADA
}

export const AgendamentoCadastroView = (props: AgendamentoCadastroViewProps) => {
  const {
    lotacao,
    onSubmit,
    onClose,
    start,
    end,
    isAtencaoDomiciliar = false,
    defaultTab = TipoAgendamento.CONSULTA,
  } = props

  const [activeTab, setActiveTab] = useState(defaultTab)
  const isActiveTabAsConsulta = activeTab === TipoAgendamento.CONSULTA
  const isActiveTabAsReserva = activeTab === TipoAgendamento.RESERVA
  const isActiveTabAsConsultaCompartilhada = activeTab === TipoAgendamento.CONSULTA_COMPARTILHADA

  return (
    <AgendamentoBox>
      <VFlow>
        <LotacaoCadastroAgendamentoText lotacao={lotacao} />
        <ButtonGroup>
          <Button
            kind={isActiveTabAsConsulta ? 'primary' : 'normal'}
            size='small'
            onClick={() => setActiveTab(TipoAgendamento.CONSULTA)}
          >
            Consulta
          </Button>
          <Button
            kind={isActiveTabAsReserva ? 'primary' : 'normal'}
            size='small'
            onClick={() => setActiveTab(TipoAgendamento.RESERVA)}
          >
            Reserva
          </Button>
          {!isAtencaoDomiciliar && (
            <Button
              kind={isActiveTabAsConsultaCompartilhada ? 'primary' : 'normal'}
              size='small'
              onClick={() => setActiveTab(TipoAgendamento.CONSULTA_COMPARTILHADA)}
            >
              Entre profissionais
            </Button>
          )}
        </ButtonGroup>
        {isActiveTabAsReserva && (
          <AgendamentoReservaForm
            start={start}
            end={end}
            isAtencaoDomiciliar={isAtencaoDomiciliar}
            onClose={onClose}
            lotacaoId={lotacao.id}
            onSubmit={onSubmit}
          />
        )}
        {isActiveTabAsConsulta && (
          <AgendamentoConsultaForm
            start={start}
            end={end}
            isAtencaoDomiciliar={isAtencaoDomiciliar}
            onClose={onClose}
            lotacao={lotacao}
            onSubmit={onSubmit}
          />
        )}
        {!isAtencaoDomiciliar && isActiveTabAsConsultaCompartilhada && (
          <AgendamentoConsultaCompartilhadaForm
            start={start}
            end={end}
            onClose={onClose}
            lotacao={lotacao}
            onSubmit={onSubmit}
          />
        )}
      </VFlow>
    </AgendamentoBox>
  )
}
